import {useReviewersLiveUpdates} from '../../../hooks/use-reviewers-live-updates'
import {useLayoutQuery} from '../../../page-data/loaders/use-layout-query'
import {useReviewRequestsQuery} from './route-queries'

export function useReviewers() {
  const {data: layoutData} = useLayoutQuery()
  useReviewersLiveUpdates(layoutData?.aliveChannels)

  return useReviewRequestsQuery()
}
